
import { useEffect, useState } from 'react';

interface StreakData {
  currentStreak: number;
  longestStreak: number;
  lastLoginDate: string;
}

export const StreakCounter = () => {
  const [streak, setStreak] = useState<StreakData>({
    currentStreak: 0,
    longestStreak: 0,
    lastLoginDate: ''
  });

  useEffect(() => {
    // Carregar streak do localStorage
    const savedStreak = localStorage.getItem('userStreak');
    const today = new Date().toDateString();

    if (savedStreak) {
      const data: StreakData = JSON.parse(savedStreak);
      const lastLogin = new Date(data.lastLoginDate).toDateString();
      const yesterday = new Date(Date.now() - 86400000).toDateString();

      if (lastLogin === today) {
        // Já logou hoje
        setStreak(data);
      } else if (lastLogin === yesterday) {
        // Logou ontem, incrementa streak
        const newStreak = {
          currentStreak: data.currentStreak + 1,
          longestStreak: Math.max(data.longestStreak, data.currentStreak + 1),
          lastLoginDate: new Date().toISOString()
        };
        setStreak(newStreak);
        localStorage.setItem('userStreak', JSON.stringify(newStreak));
      } else {
        // Quebrou a sequência
        const newStreak = {
          currentStreak: 1,
          longestStreak: data.longestStreak,
          lastLoginDate: new Date().toISOString()
        };
        setStreak(newStreak);
        localStorage.setItem('userStreak', JSON.stringify(newStreak));
      }
    } else {
      // Primeiro login
      const newStreak = {
        currentStreak: 1,
        longestStreak: 1,
        lastLoginDate: new Date().toISOString()
      };
      setStreak(newStreak);
      localStorage.setItem('userStreak', JSON.stringify(newStreak));
    }
  }, []);

  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-6 text-white">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-fire-fill text-3xl"></i>
          </div>
          <div>
            <div className="text-sm opacity-90">Sequência Atual</div>
            <div className="text-3xl font-bold">{streak.currentStreak} dias</div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-sm opacity-90">Recorde</div>
          <div className="text-2xl font-bold">{streak.longestStreak} dias</div>
        </div>
      </div>
      
      <div className="flex gap-2 mt-4">
        {[...Array(7)].map((_, index) => (
          <div
            key={index}
            className={`flex-1 h-2 rounded-full transition-all ${
              index < streak.currentStreak % 7 || (streak.currentStreak >= 7 && index < 7)
                ? 'bg-white'
                : 'bg-white/20'
            }`}
          ></div>
        ))}
      </div>
      
      <div className="text-center mt-4 text-sm opacity-90">
        {streak.currentStreak >= 7 ? '🔥 Você está em chamas!' : `Continue por mais ${7 - (streak.currentStreak % 7)} dias para completar a semana!`}
      </div>
    </div>
  );
};
